import React from 'react';

const OptimizedImage = ({ src, alt, style, className }) => {
  // Remove any media queries from the style object
  const cleanStyle = { ...style };
  
  return (
    <img
      src={src}
      alt={alt}
      style={cleanStyle}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
};

export default OptimizedImage; 